import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Property } from '@shared/api/property/property.model';
import { PropertyService } from '@shared/api';

@Injectable({
  providedIn: 'root'
})
export class PropertySharedService {
  propertyDetails: Property;
  isPropertyDetailsEmpty: boolean = true;
  isPropertyWaiting: boolean = false;

  constructor(private router: Router, private _property: PropertyService) {}

  setPropertyDetails(status = false) {
    if (this.isPropertyDetailsEmpty && !this.isPropertyWaiting && status) {
      this.isPropertyWaiting = true;
      const split = this.router.url.split('/');
      if (split && split.length && split[3]) {
        this._property.getPropertyDetails(split[3]).subscribe(data => {
          this.propertyDetails = data;
          this.isPropertyDetailsEmpty = false;
          this.isPropertyWaiting = false;
        });
      }
    } else {
      this.isPropertyDetailsEmpty = true;
      this.propertyDetails = new Property();
    }
  }

  getPropertyDetails() {
    return new Promise<Property>(resolve => {
      setTimeout(() => {
        resolve(this.propertyDetails);
      }, 2000);
    });
  }

  purchaseProperty() {
    this.router.navigate(['/app/purchase']);
  }
}
